import { ApplicationStore } from "src/store";

export const hasTestDrive = (state: ApplicationStore) => state.testDrive !== null;

export const getTestDriveDate = (state: ApplicationStore) => state.testDrive?.date;

export const getTestDriveTime = (state: ApplicationStore) => state.testDrive?.time;
